export enum AllSwitchFilterNames {
  MFWOriginals = 'showMFWOriginals',
  OrgOriginals = 'showORGOriginals',
  PremiumContent = 'showPremium',
  NetContent = 'showPublic',
  MyNetContent = 'showMyMfwNet',
  MarketplaceContent = 'isLockedContentDisplayed',
  Archived = 'archived'
}

export type SwitchFilterNames =
  | 'showMFWOriginals'
  | 'showORGOriginals'
  | 'showPremium'
  | 'showPublic'
  | 'isLockedContentDisplayed'
  | 'showMyMfwNet'
  | 'archived';
  
export type SwitchType = 'multi' | 'one_only';
export type SwitchColor ='primary' | 'secondary';

export const FilterExclusivity = {
  one_only: ["showPublic", "showPremium", "isLockedContentDisplayed", "showMyMfwNet", "archived"],
  multiple: ["showMFWOriginals", "showORGOriginals"],
};
 export  interface SwitchConfigInterface {
    name: SwitchFilterNames;
    condition: boolean;
    iconColor: SwitchColor;
    switchColor: SwitchColor;
    switchType: SwitchType;
    column: 1 | 2,
    onExtraChange?: (checked: boolean) => void;
  }